import { defineStore } from "pinia";
import { instance } from "../index";
import { FeedbackRest } from "@/services/rest/feedback.rest";
import { useLearningObjectiveStore } from "./learning-objective";
import { useAdaptCourseStore } from "./adapt-course";
import { firstValueFrom, take } from "rxjs";
import { RouteMaterials, useAdaptMaterialStore } from "./adapt-material";
import { useAuthStore } from "../auth";
import { FeedbackObjective } from "@/models/learning-objective.model";
import { QueryParams } from "@/models/query-params.model";
import { useAdaptChapterStore } from "./adapt-chapter";
import { StatusProgress, useAdaptProgressStore } from "./adapt-progress";
import { TypeAlert, useAlertStore } from "./alert";

export enum EFeedback {
  OBJECTIVE = "objective",
}

export const store = defineStore({
  id: "feedback",
  state: () => ({
    feedback: false,
    type: EFeedback.OBJECTIVE,
  }),
  actions: {
    set(type: EFeedback) {
      this.feedback = true;
      type = type;
    },

    async sendFeedback(data: FeedbackObjective) {
      const studentId = useAuthStore?.data.id;
      const params = {
        classroomId: localStorage.getItem("classId") ?? undefined,
      } as QueryParams;
      const courseId = useAdaptCourseStore?.course.courseId;
      const learningObjectiveId =
        useLearningObjectiveStore?.learningObjective?.id;
      data.learningObjectiveId = learningObjectiveId;

      const response = await firstValueFrom(
        new FeedbackRest()
          .sendLearningObjectFeedback(studentId, courseId, data, params)
          .pipe(take(1))
      );
      this.feedback = false;

      
      await this.handleMaterialsResponse(
        response,
        studentId,
        courseId,
        RouteMaterials.NEXT
      );
      useAdaptChapterStore?.handleChapterResponse(response);
      this.setNextProgressStep(response);
      useAdaptProgressStore?.setNextState();
    },
    async handleMaterialsResponse(
      response: any,
      userId: string,
      courseId: string,
      RouteMaterial?: RouteMaterials
    ) {
      useAdaptMaterialStore.routeMaterial =
        RouteMaterial ?? RouteMaterials[response.learningObjectiveStatus];
      await useAdaptMaterialStore?.setMaterials(
        courseId,
        userId,
      );
    },
    setNextProgressStep(response) {
      
      if (response.currentChapter !== useAdaptChapterStore.chapter.id)
        useAdaptProgressStore.status = StatusProgress.INIT_CHAPTER;
      else {
        useAlertStore?.setCurrentAlert(TypeAlert.INTRO_OBJECTIVE, true);
      }
    },
  },
});
export const useFeedbackStore = store(instance);
